module.exports = __webpack_public_path__ + "static/media/item_2_8ll.25d2fa79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/item_2_8ll.png
// module id = 125
// module chunks = 0